__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "plurall-tasks-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.507", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(283), __webpack_require__.e(805), __webpack_require__.e(534), __webpack_require__.e(205), __webpack_require__.e(218)]).then(() => (() => (__webpack_require__(20269))))));
			register("@sentry/react", "7.71.0", () => (Promise.all([__webpack_require__.e(391), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(83391))))));
			register("axios", "0.18.1", () => (__webpack_require__.e(505).then(() => (() => (__webpack_require__(72505))))));
			register("client-oauth2", "4.3.3", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(937)]).then(() => (() => (__webpack_require__(26710))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(43), __webpack_require__.e(396)]).then(() => (() => (__webpack_require__(15043))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "5.1.1", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-device-detect", "1.17.0", () => (Promise.all([__webpack_require__.e(661), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(15042))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-infinite-scroller", "1.2.6", () => (Promise.all([__webpack_require__.e(283), __webpack_require__.e(805), __webpack_require__.e(420)]).then(() => (() => (__webpack_require__(81420))))));
			register("react-player", "2.16.0", () => (Promise.all([__webpack_require__.e(554), __webpack_require__.e(283), __webpack_require__.e(805)]).then(() => (() => (__webpack_require__(13554))))));
			register("react-responsive", "8.2.0", () => (Promise.all([__webpack_require__.e(988), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(17988))))));
			register("react-responsive", "9.0.2", () => (Promise.all([__webpack_require__.e(790), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(65790))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(876), __webpack_require__.e(283), __webpack_require__.e(805)]).then(() => (() => (__webpack_require__(30876))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("snakecase-keys", "1.2.0", () => (__webpack_require__.e(694).then(() => (() => (__webpack_require__(99694))))));
			initExternal(81811);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};